
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
outline-styled-text-baseline{
  --body-color:var(--alert-text-color, var(--brand-white));
}

.emergency-takeover-wrapper{
  height:100vh;
  width:100%;
  position:fixed;
  z-index:9999;
  inset:0;
}

.emergency-takeover-container{
  height:100%;
  width:100%;
  display:flex;
  flex-direction:column;
  position:relative;
  padding:var(--spacing-4);
  padding-top:var(--spacing-24);
}

@media (min-width: 768px){

.emergency-takeover-container{
    justify-content:center;
    padding-top:var(--spacing-4);
}
  }

.emergency-takeover-container{
  background-color:var(--brand-dark-blue-900);
  color:var(--brand-white);
  color:var(--alert-text-color, var(--brand-white));
}

.emergency-takeover-content{
  display:flex;
  flex-direction:column;
  color:var(--brand-white);
  color:var(--alert-text-color, var(--brand-white));
}

.emergency-takeover-close{
  position:absolute;
  top:var(--spacing-12);
  right:var(--spacing-8);
  display:flex;
  justify-content:center;
  border-radius:4px;
  align-items:center;
  width:32px;
  height:32px;
  color:var(--brand-dark-blue-900);
  background-color:var(--brand-bright-blue-900);
  border:none;
  transition:transform 0.25s ease;
}

.emergency-takeover-close:focus{
    outline:2px solid var(--brand-white);
    offset:2px;
  }

.emergency-takeover-close:hover{
    transform:scale(1.15);
  }

.emergency-takeover-icon{
  color:var(--brand-white);
  color:var(--alert-text-color, var(--brand-white));
  margin-bottom:var(--spacing-4);
}

outline-heading-baseline[ruled]::after{
  border:solid var(--brand-red-700);
  border-width:8px 0 0;
}

div[slot='body']{
  margin-bottom:var(--spacing-6);
}

.btn{
  width:100%;
  justify-content:center;
}

@media (min-width: 768px){

.btn{
    width:auto;
    justify-content:flex-start
}
  }
`;